/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@digital-hig/typography';
import { useTranslation } from 'react-i18next';
import CompanyRootElement from '../CompanyInformation/style';
import { ProfileContextConsumer } from '../../../common/context/profile/context';
import { DEFAULT_ACCORDION_SIZE } from '../../../constants/app-constants';
import AccordionList, { isItemAvailableInside } from '../../../common/accordionList';

const Specializations = ({ profileDetails, loading, scrollRef }) => {
  const { specializations } = profileDetails || {};
  const { t } = useTranslation();
  let isValidItems = false;
  if (specializations) {
    isValidItems = Object.keys(specializations).map((item) => isItemAvailableInside(item, specializations)).includes(true);
  }
  return (
    // eslint-disable-next-line
    <CompanyRootElement ref={(el) => (scrollRef.current[3] = el)}>
      {isValidItems && (
        <Box className="page-container">
          <Typography variant="headline-medium" mb={2} component="h3">
            {t('Specializations')}
          </Typography>
          <Typography variant="body-copy-medium" mb={7} className="sub-description">
            <strong>{t('Specialized')}</strong>
            {' '}
            {t('partners have met Autodesk’s base standards for certified staff capacity, capabilities, and performance in delivering on desired customer outcomes within an industry segment.')}
          </Typography>
          <AccordionList
            items={specializations}
            dataWatLoc="specializations"
            loading={loading}
            size={DEFAULT_ACCORDION_SIZE}
            imgKey="badge"
            titleKey="title"
          />
        </Box>
      )}
    </CompanyRootElement>
  );
};

Specializations.propTypes = {
  profileDetails: PropTypes.shape({}),
  loading: PropTypes.bool,
  scrollRef: PropTypes.shape({}),
};
Specializations.defaultProps = {
  profileDetails: {},
  loading: false,
  scrollRef: {},
};
export default ProfileContextConsumer(Specializations);
